import { validateNaturalDocument } from './validateNaturalDocument';
import { validateLegalDocument } from './validateLegalDocument';

const normalizeDocument = (document: string): string =>
  document.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

export function validateDocument(document: string): boolean {
  if (typeof document !== 'string') return false;

  const normalizedDocument = normalizeDocument(document);

  if (/[A-Z]/.test(normalizedDocument) || normalizedDocument.length > 11) {
    return validateLegalDocument(normalizedDocument);
  }

  return validateNaturalDocument(normalizedDocument);
}
